import React, { useContext } from 'react';
import { InternalSettlementFilters } from '../../../../app/models/InternalSettlement';
import { AuthContext } from '../../../../contexts/AuthContext';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';
import { Worker } from '../../../../app/models/Workers'
import { getMonthDateRange } from '../../../../helpers';


type Props = {
    filter: InternalSettlementFilters;
    setFilter: (filter: InternalSettlementFilters) => void;
    onSearch: () => void;
    workers: Worker[]
};

const InternalSettlementsFilter = ({ filter, setFilter, onSearch, workers }: Props) => {
    const { auth } = useContext(AuthContext);

    const handlerInputMonthFilter = (e: React.ChangeEvent<HTMLInputElement>) => {

        const { startDate, endDate } = getMonthDateRange(e.target.value);
        
        setFilter({
            ...filter,
            'issue_date_from': startDate,
            'issue_date_until': endDate,
            [e.target.name]: e.target.value
        });
    };

    
    const handleChangeSelectTwo = (name: string, value: number | string | null) => {
        const obj = { [name]: value };
        setFilter({ ...filter, ...obj });
    };

    return (
        <>

            {(auth?.hasAllPermissions || !auth?.roles?.includes('Conductor')) && (
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="font-size-10 mb-1" htmlFor="carrier">
                                Conductor
                            </label>

                            <SelectTwo
                                name="worker_id"
                                id="worker_id"
                                inputValue={filter.worker_id}
                                options={SelectTwoMapperOptions(workers, 'id', ['name'])}
                                placeholder={'Seleccione Conductor'}
                                onChange={(value: any) =>
                                    handleChangeSelectTwo('worker_id', value?.value)
                                }
                            />
                        </div>
                    </div>
                </div>
            )}
            
            <div className="row justify-content-start">
                  <div className="col-lg-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="issue_date_from">
                            Mes
                        </label>
                        <input
                            title="Fecha de emisión"
                            type="month"
                            id="month"
                            name="month"
                            className="form-control form-control-sm"
                            value={filter.month}
                            onChange={(e) => handlerInputMonthFilter(e)}
                        />
                    </div>
                </div>

                {/* Inputs de fechas por día para filtrar, si filtro de mes está OK eliminar esto */}
                {/* <div className="col-lg-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="issue_date_from">
                            Fecha de emisión (desde)
                        </label>
                        <input
                            title="Fecha de emisión"
                            type="date"
                            id="issue_date_from"
                            name="issue_date_from"
                            className="form-control form-control-sm"
                            value={filter.issue_date_from}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div>
                <div className="col-lg-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="issue_date_until">
                            Fecha de emisión (hasta)
                        </label>
                        <input
                            title="Fecha de emisión"
                            type="date"
                            id="issue_date_until"
                            name="issue_date_until"
                            className="form-control form-control-sm"
                            value={filter.issue_date_until}
                            onChange={(e) => handlerInputFilter(e)}
                        />
                    </div>
                </div> */}

                <div className='col-md-auto'>
                    <div style={{marginTop: '22px'}}>
                        <ButtonSearchFilter callbackSearch={onSearch}/>
                    </div>
                </div>

                


            </div>
        </>
    );
};

export default InternalSettlementsFilter;
